import type { Ref } from 'vue';

/**
 * Reads a ref's value so the surrounding reactive scope (computed/render) registers a
 * dependency on it, then returns the value. Used to force a re-measure when a layout-version
 * counter changes even though the value itself is not otherwise consumed.
 */
export function trackReactiveDep<T>(source?: Ref<T>): T | undefined {
  return source?.value;
}
